export const ColumnIdentifier = {
  title: 'title',
  description: 'description',
  attachment: 'attachment',
  institution: 'institution',
};
